import { apiFetch } from "@/lib/api";

export type Partner = {
  id: number;
  name: string;
  business_type: "operator" | "agency";
  country?: string | null;
  address?: string | null;
  referred_from?: string | null;
  source_prospect_id?: number | null;
  owner_id?: string | null;
  created_by?: string | null;
  contacts?: Array<{
    name?: string | null;
    position?: string | null;
    email?: string | null;
    telephone?: string | null;
    is_primary?: boolean | null;
    no_response?: boolean | null;
  }> | null;
  created_at?: string | null;
  updated_at?: string | null;
};

export type PartnerListItem = {
  id: number;
  name: string;
  business_type?: "operator" | "agency" | null;
  country?: string | null;
  address?: string | null;
  updated_at?: string | null;
};

export type PartnerListResponse = {
  items: PartnerListItem[];
  total: number;
};

export const fetchPartners = async (params: {
  page: number;
  size: number;
  search?: string;
  sortField?: string | null;
  sortOrder?: string | null;
}): Promise<PartnerListResponse> => {
  const query = new URLSearchParams();
  query.set("page", String(params.page));
  query.set("size", String(params.size));
  if (params.search) query.set("search", params.search);
  if (params.sortField) query.set("sortField", params.sortField);
  if (params.sortOrder) query.set("sortOrder", params.sortOrder);
  const payload = await apiFetch<PartnerListResponse | null>(`/partners?${query.toString()}`);
  return payload ?? { items: [], total: 0 };
};

export const getPartner = async (id: number): Promise<Partner> => {
  return apiFetch<Partner>(`/partners/${id}`);
};

export const createPartner = async (data: Partial<Partner>): Promise<Partner> => {
  return apiFetch<Partner>("/partners", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updatePartner = async (id: number, data: Partial<Partner>): Promise<Partner> => {
  return apiFetch<Partner>(`/partners/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deleteAllPartnersByBusinessType = async (businessType: "agency" | "operator"): Promise<void> => {
  const query = new URLSearchParams();
  query.set("business_type", businessType);
  await apiFetch<void>(`/partners?${query.toString()}`, { method: "DELETE" });
};
